<!-- prettier-ignore -->

<input #inputStreet (focusin)="focusin($event)" class="google-map-places-input" size="5" />